export enum ComponentName {
  PersonalInfoComponent = 'PersonalInfoComponent',
  ResidenceInfoComponent = 'ResidenceInfoComponent',
  PreviousResidenceInfoComponent = 'PreviousResidenceInfoComponent',
  EmploymentInfoComponent = 'EmploymentInfoComponent',
  PreviousEmploymentInfoComponent = 'PreviousEmploymentInfoComponent',
  AdditionalInfoComponent = 'AdditionalInfoComponent',
  CoBuyerPersonalInfoComponent = 'CoBuyerPersonalInfoComponent',
  CoBuyerResidenceInfoComponent = 'CoBuyerResidenceInfoComponent',
  CoBuyerPreviousResidenceInfoComponent = 'CoBuyerPreviousResidenceInfoComponent',
  CoBuyerEmploymentInfoComponent = 'CoBuyerEmploymentInfoComponent',
  CoBuyerPreviousEmploymentInfoComponent = 'CoBuyerPreviousEmploymentInfoComponent',
  CoBuyerAdditionalInfoComponent = 'CoBuyerAdditionalInfoComponent',
  ReviewInfoComponent = 'ReviewInfoComponent',
  BankOffersComponent = 'BankOffersComponent',
  ConfirmationPageComponent = 'ConfirmationPageComponent',
  UnlockComponent = 'UnlockComponent',
  PreQualComponent = 'PreQualComponent',
  PreQualConfirmationComponent = 'PreQualConfirmationComponent',
}
